export default "__VITE_ASSET__X$hf7xZ7__"